import React from 'react';
import PropTypes from 'prop-types';

function HeaderProfile({ user, embodies }) {
  if (user.nomeCompleto) {
    console.log('stato di embodies:', embodies);
    let welcome = `${user.nomeCompleto} - matr. ${user.matricola}`;
    if (embodies && embodies != null) {
      welcome = `${welcome} - Impersonifica: ${embodies}`;
    }
    return (
      <div>
        <span>{welcome}</span>
      </div>
    );
  }
  return (
    <div>
      <span>Utente non loggato</span>
    </div>
  );
}

HeaderProfile.propTypes = {
  user: PropTypes.object,
  embodies: PropTypes.string,
};

export default HeaderProfile;
